<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="m-portlet m-portlet--tab">
          <div class="m-portlet__body">
            <div>
              <!-- <span class="loading-request" v-show="loading"></span> -->
              <div
                class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pb-2 mb-4 border-bottom"
              >
                <h1 class="h2">Gerar Relatório</h1>
                <div class="btn-toolbar mb-2 mb-md-0">
                  <div
                    class="btn-group btn-group-sm"
                    role="group"
                    aria-label="Menu dos Consumo"
                  >
                    <a
                      class="mr-2"
                      href
                      data-toggle="modal"
                      @click="callData()"
                    >
                      <button
                        class="btn btn-outline-brand m-btn m-btn--outline"
                        :disabled="!formIsValid"
                      >
                        <i class="fas fa-sync-alt"></i> Gerar
                      </button>
                    </a>

                    <a
                      href
                      data-toggle="modal"
                      onclick="window.print();return false;"
                    >
                      <button
                        class="btn btn-outline-brand m-btn m-btn--outline"
                      >
                        <i class="fas fa-print"></i> Imprimir
                      </button>
                    </a>
                  </div>
                </div>
              </div>

              <div class="row mb-3">
                <div
                  :class="{
                    'col-md-6': !showCreateAtFilter,
                    'col-md-4': showCreateAtFilter,
                  }"
                >
                  <label for="start_date">
                    Data Início (mm/yyyy)
                    <span class="m--font-danger">*</span>
                  </label>
                  <div class="input-group">
                    <input
                      id="start_date"
                      type="text"
                      ref="start_date"
                      class="form-control m-input"
                      placeholder="mm/aaaa"
                      v-model="data.start_date"
                      @change="setFilter('start_date', data.start_date)"
                      v-mask="'##/####'"
                      :disabled="
                        this.filters.report_type == 'ReportActives' ||
                        this.filters.report_type == 'ReportMonthlyData' ||
                        this.filters.report_type ==
                          'ReportConsumptionAnalytics' ||
                        this.filters.report_type ==
                          'ReportContractsReadjustment' ||
                        this.filters.report_type == 'ReportContractsChange' ||
                        this.filters.report_type == 'ReportPartialInvoiceConsumption'
                      "
                    />
                  </div>
                </div>
                <div
                  :class="{
                    'col-md-6': !showCreateAtFilter,
                    'col-md-4': showCreateAtFilter,
                  }"
                >
                  <label for="finish_date">
                    Data Final (mm/yyyy)
                    <span class="m--font-danger">*</span>
                  </label>
                  <div class="input-group">
                    <input
                      id="finish_date"
                      type="text"
                      ref="finish_date"
                      class="form-control m-input"
                      placeholder="mm/aaaa"
                      v-model="data.finish_date"
                      @change="setFilter('finish_date', data.finish_date)"
                      v-mask="'##/####'"
                      :disabled="
                        this.filters.report_type == 'ReportActives' ||
                        this.filters.report_type == 'ReportMonthlyData' ||
                        this.filters.report_type ==
                          'ReportConsumptionAnalytics' ||
                        this.filters.report_type ==
                          'ReportContractsAnalytical' ||
                        this.filters.report_type ==
                          'ReportContractsReadjustment' ||
                        this.filters.report_type == 'ReportContractsChange' ||
                        this.filters.report_type == 'ReportPartialInvoiceConsumption'
                      "
                    />
                  </div>
                </div>
                <div class="col-md-2" v-if="showCreateAtFilter">
                  <label for="finish_date"> Data de Faturamento/Emissão </label>
                  <div class="input-group">
                    <input
                      id="created_at"
                      type="text"
                      ref="created_at"
                      class="form-control m-input"
                      placeholder="mm/aaaa"
                      v-model="data.created_at"
                      @change="setFilter('created_at', data.created_at)"
                      v-mask="'##/####'"
                    />
                  </div>
                </div>
              </div>

              <hr class="row mt-5 mb-3" />

              <div
                id="alert"
                class="alert alert-dismissible fade show m-alert m-alert--outline mb-4 mt-4"
                :class="alert.color"
                role="alert"
                v-if="alert.message"
              >
                <button
                  type="button"
                  class="close"
                  aria-label="Close"
                  @click="alert.message = ''"
                ></button>
                <i :class="alert.icon"></i> &nbsp;
                <strong>{{ alert.message }}</strong>
                <br />
                {{ alert.reason }}
              </div>
              <div class="col-md-6">
                <SelectReportGeneral
                  :selected="filters.report_type"
                  @change="setFilter('report_type', $event)"
                  class="mr-2"
                  v-b-tooltip.hover
                  title="Selecione o tipo de relatório"
                />
              </div>
            </div>
            <br />
            <span class="loading-request" v-show="loading"></span>
            <ReportDiscount
              v-if="this.filters.report_type == 'ReportDiscounts'"
              :start="data.start_date"
              :finish="data.finish_date"
              ref="ReportDiscounts"
              v-on:updateLoading="handleLoading"
            />

            <ReportAppliedDiscount
              v-if="this.filters.report_type == 'ReportAppliedDiscount'"
              :start="data.start_date"
              :finish="data.finish_date"
              ref="ReportAppliedDiscount"
              v-on:updateLoading="handleLoading"
            />

            <ReportContracts
              v-if="this.filters.report_type == 'ReportContracts'"
              :start="data.start_date"
              :finish="data.finish_date"
              ref="ReportContracts"
              v-on:updateLoading="handleLoading"
            />

            <ReportInvoices
              v-if="this.filters.report_type == 'ReportInvoices'"
              :start="data.start_date"
              :finish="data.finish_date"
              ref="ReportInvoices"
              v-on:updateLoading="handleLoading"
            />

            <ReportProcessingHistory
              v-if="this.filters.report_type == 'ReportProcessingHistory'"
              :start="data.start_date"
              :finish="data.finish_date"
              ref="ReportProcessingHistory"
              v-on:updateLoading="handleLoading"
            />

            <ReportCustomers
              v-if="this.filters.report_type == 'ReportCustomers'"
              :start="data.start_date"
              :finish="data.finish_date"
              ref="ReportCustomers"
              v-on:updateLoading="handleLoading"
            />

            <ReportActives
              v-if="this.filters.report_type == 'ReportActives'"
              :start="data.start_date"
              :finish="data.finish_date"
              ref="ReportActives"
              v-on:updateLoading="handleLoading"
            />

            <ReportMonthlyData
              v-if="this.filters.report_type == 'ReportMonthlyData'"
              :start="data.start_date"
              :finish="data.finish_date"
              ref="ReportMonthlyData"
              v-on:updateLoading="handleLoading"
            />

            <ReportContractsChatbotNoConsumption
              v-if="
                this.filters.report_type ==
                'ReportContractsChatbotNoConsumption'
              "
              :start="data.start_date"
              :finish="data.finish_date"
              ref="ReportContractsChatbotNoConsumption"
              v-on:updateLoading="handleLoading"
            />

            <ReportRelationGriffinMktzap
              v-if="this.filters.report_type == 'ReportRelationGriffinMktzap'"
              :start="data.start_date"
              :finish="data.finish_date"
              ref="ReportRelationGriffinMktzap"
              v-on:updateLoading="handleLoading"
            />

            <ReportConsumptionAnalytics
              v-if="this.filters.report_type == 'ReportConsumptionAnalytics'"
              :start="data.start_date"
              :finish="data.finish_date"
              ref="ReportConsumptionAnalytics"
              v-on:updateLoading="handleLoading"
            />

            <ReportContractsAnalytical
              v-if="this.filters.report_type == 'ReportContractsAnalytical'"
              :start="data.start_date"
              :finish="data.finish_date"
              ref="ReportContractsAnalytical"
              v-on:updateLoading="handleLoading"
            />

            <ReportContractsReadjustment
              v-if="this.filters.report_type == 'ReportContractsReadjustment'"
              :start="data.start_date"
              :finish="data.finish_date"
              ref="ReportContractsReadjustment"
              v-on:updateLoading="handleLoading"
            />

            <ReportCustomersCnae
              v-if="this.filters.report_type == 'ReportCustomersCnae'"
              :start="data.start_date"
              :finish="data.finish_date"
              ref="ReportCustomersCnae"
              v-on:updateLoading="handleLoading"
            />

            <ReportInvoiceAnalytics
              v-if="this.filters.report_type == 'ReportInvoiceAnalytics'"
              :start="data.start_date"
              :finish="data.finish_date"
              :createdAt="data.created_at"
              ref="ReportInvoiceAnalytics"
              v-on:updateLoading="handleLoading"
            />
            <ReportContractsChange
              v-if="this.filters.report_type == 'ReportContractsChange'"
              ref="ReportContractsChange"
              v-on:updateLoading="handleLoading"
            />
            <ReportInvoiceAnalyticConsumptions
              v-if="
                this.filters.report_type == 'ReportInvoiceAnalyticConsumptions'
              "
              :start="data.start_date"
              :finish="data.finish_date"
              :createdAt="data.created_at"
              ref="ReportInvoiceAnalyticConsumptions"
              v-on:updateLoading="handleLoading"
            />
            <ReportCustomerGriffinMktzap
              v-if="this.filters.report_type == 'ReportCustomerGriffinMktzap'"
              :start="data.start_date"
              :finish="data.finish_date"
              ref="ReportCustomerGriffinMktzap"
              v-on:updateLoading="handleLoading"
            />

            <ReportInvoiceAnalyticsByGroup
              v-if="this.filters.report_type == 'ReportInvoiceAnalyticsByGroup'"
              :start="data.start_date"
              :finish="data.finish_date"
              ref="ReportInvoiceAnalyticsByGroup"
              v-on:updateLoading="handleLoading"
            />

            <ReportCustomerAttendanceProtocol
              v-if="
                this.filters.report_type == 'ReportCustomerAttendanceProtocol'
              "
              :start="data.start_date"
              :finish="data.finish_date"
              ref="ReportCustomerAttendanceProtocol"
              v-on:updateLoading="handleLoading"
            />

            <ReportInvoiceCategories
              v-if="this.filters.report_type == 'ReportInvoiceCategories'"
              :start="data.start_date"
              :finish="data.finish_date"
              ref="ReportInvoiceCategories"
              v-on:updateLoading="handleLoading"
            />

            <ReportInvoiceAnalyticsGeneral
              v-if="this.filters.report_type == 'ReportInvoiceAnalyticsGeneral'"
              :start="data.start_date"
              :finish="data.finish_date"
              :createdAt="data.created_at"
              ref="ReportInvoiceAnalyticsGeneral"
              v-on:updateLoading="handleLoading"
            />

            <ReportPartialInvoiceConsumption
              v-if="this.filters.report_type == 'ReportPartialInvoiceConsumption'"
              :start="data.start_date"
              :finish="data.finish_date"
              :createdAt="data.created_at"
              ref="ReportPartialInvoiceConsumption"
              v-on:updateLoading="handleLoading"
            />

            <div>
              <div class="paginator-info-bottom mt-2">
                <span class="m--font-gray" v-if="data.from"
                  >Exibindo itens de {{ data.from }} a {{ data.to }}, de um
                  total de {{ data.total }}.</span
                >
              </div>
            </div>
            <div class="pt-4"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SelectReportGeneral from '@/components/forms/SelectReportGeneral';
import { returnMessageMixin } from '@/mixins/returnMessageMixin';
import ReportDiscount from './discount/ReportDiscount';
import ReportAppliedDiscount from './discount/ReportAppliedDiscount';
import ReportContracts from './contracts/ReportContracts';
import ReportInvoices from './invoice/ReportInvoices';
import ReportProcessingHistory from './invoice/ReportProcessingHistory';
import ReportCustomers from './customers/ReportCustomers';
import ReportActives from './actives/ReportActives';
import ReportMonthlyData from './monthlyData/ReportMonthlyData';
import ReportContractsChatbotNoConsumption from './contracts/ReportContractsChatbotNoConsumption';
import ReportRelationGriffinMktzap from './relationGriffinMktzap/RelationGriffinMktzap';
import ReportConsumptionAnalytics from './consumption/ReportConsumptionAnalytics';
import ReportContractsAnalytical from './contracts/ReportContractsAnalytical';
import ReportContractsReadjustment from './contracts/ReportContractsReadjustment';
import ReportCustomersCnae from './customers/ReportCustomersCnae';
import ReportInvoiceAnalytics from './invoice/ReportInvoiceAnalytics';
import ReportContractsChange from './contracts/ReportContractsChange';
import ReportInvoiceAnalyticConsumptions from './invoice/ReportInvoiceAnalyticConsumptions';
import ReportCustomerGriffinMktzap from './comparationGriffinMkzap/ReportCustomerGriffinMktzap.vue';
import ReportInvoiceAnalyticsByGroup from './invoice/ReportInvoiceAnalyticsByGroup';
import ReportCustomerAttendanceProtocol from './customers/ReportCustomerAttendanceProtocol';
import ReportInvoiceCategories from './invoice/ReportInvoiceCategories.vue';
import ReportInvoiceAnalyticsGeneral from './invoice/ReportInvoiceAnalyticsGeneral.vue';
import ReportPartialInvoiceConsumption from './invoice/ReportPartialInvoiceConsumption.vue';

export default {
  mixins: [returnMessageMixin],
  name: 'ReportGeneral',
  components: {
    SelectReportGeneral,
    ReportDiscount,
    ReportAppliedDiscount,
    ReportContracts,
    ReportInvoices,
    ReportProcessingHistory,
    ReportCustomers,
    ReportActives,
    ReportMonthlyData,
    ReportContractsChatbotNoConsumption,
    ReportRelationGriffinMktzap,
    ReportConsumptionAnalytics,
    ReportContractsAnalytical,
    ReportContractsReadjustment,
    ReportCustomersCnae,
    ReportInvoiceAnalytics,
    ReportContractsChange,
    ReportInvoiceAnalyticConsumptions,
    ReportCustomerGriffinMktzap,
    ReportInvoiceAnalyticsByGroup,
    ReportCustomerAttendanceProtocol,
    ReportInvoiceCategories,
    ReportInvoiceAnalyticsGeneral,
    ReportPartialInvoiceConsumption,
  },
  data() {
    return {
      trigger: 0,
      showCreateAtFilter: false,
      data: {},
      filters: {
        id: '',
        report_type: '',
        report_selected: false,
      },
      alert: {
        color: 'alert-primary',
        icon: 'fas fa-spinner fa-spin fa-lg',
        message: '',
        reason: '',
      },
      loading: false,
    };
  },
  computed: {
    // loadingq() {
    //   return !this.data.current_page;
    // },
    formIsValid() {
      if (this.filters.report_type) {
        if (
          (this.filters.report_type == 'ReportCustomerAttendanceProtocol' ||
            this.filters.report_type == 'ReportInvoices') &&
          !this.data.start_date
        ) {
          return false;
        }
        return true;
      }
      return false;
    },
  },
  methods: {
    handleLoading() {
      this.loading = false;
    },
    setFilter(filterToChange, id) {
      this.clearAlert();
      if (filterToChange == 'report_type' && id != '') {
        this.showCreateAtFilter = false;
        if (
          id == 'ReportInvoiceAnalytics' ||
          id == 'ReportInvoiceAnalyticConsumptions'
        ) {
          this.showCreateAtFilter = true;
        }

        if (
          id == 'ReportActives' ||
          id == 'ReportMonthlyData' ||
          id == 'ReportConsumptionAnalytics' ||
          id == 'ReportContractsChange' ||
          id == 'ReportPartialInvoiceConsumption'
        ) {
          this.data.start_date = '';
          this.data.finish_date = '';
        }
      }

      if (this.filters.report_type == '' && filterToChange != 'report_type') {
        this.alert = {
          color: 'alert-brand',
          icon: 'fas fa-exclamation-triangle fa-lg',
          message: 'Selecione períodos e qual o tipo de relatório...',
          reason: '',
        };
      }

      if (filterToChange == 'start_date') {
        this.validDate(id, this.data.finish_date);
      }

      if (filterToChange == 'finish_date') {
        this.validDate(this.data.start_date, id);
      }

      this.filters[filterToChange] = id;
    },
    validDate(start, end) {
      if (!end || (!start && !end)) {
        this.clearAlert();
      }
      if (!start && end) {
        this.alert.message = 'Data inicial deve ser preenchida primeiro';
        this.alert.icon = 'fas fa-exclamation-triangle fa-lg';
        this.data.finish_date = '';
      }
      if (start && end) {
        if (Date.parse('01/' + start) > Date.parse('01/' + end)) {
          this.alert.message =
            'Data final precisa ser maior que data de início';
          this.alert.icon = 'fas fa-exclamation-triangle fa-lg';
          this.data.finish_date = '';
        }
      }
    },
    callData() {
      this.getDatas();
    },
    clearAlert() {
      this.alert = {
        color: 'alert-primary',
        icon: 'fas fa-spinner fa-spin fa-lg',
        message: '',
        reason: '',
      };
    },
    getDatas() {
      const $child = this.filters.report_type;
      this.loading = true;

      if (
        this.data.start_date &&
        !this.data.finish_date &&
        $child != 'ReportContractsAnalytical' &&
        $child != 'ReportContractsReadjustment'
      ) {
        this.data.finish_date = this.data.start_date;
        this.setFilter('finish_date', this.filters.start_date);
      }

      if ($child == 'ReportDiscounts') {
        return this.$refs.ReportDiscounts.generate(this.filters);
      }

      if ($child == 'ReportAppliedDiscount') {
        return this.$refs.ReportAppliedDiscount.generate(this.filters);
      }

      if ($child == 'ReportContracts') {
        return this.$refs.ReportContracts.generate(this.filters);
      }

      if ($child == 'ReportInvoices') {
        return this.$refs.ReportInvoices.generate(this.filters);
      }

      if ($child == 'ReportProcessingHistory') {
        return this.$refs.ReportProcessingHistory.generate(this.filters);
      }

      if ($child == 'ReportCustomers') {
        return this.$refs.ReportCustomers.generate(this.filters);
      }

      if ($child == 'ReportContractsChatbotNoConsumption') {
        return this.$refs.ReportContractsChatbotNoConsumption.generate(
          this.filters
        );
      }

      if ($child == 'ReportRelationGriffinMktzap') {
        return this.$refs.ReportRelationGriffinMktzap.generate(this.filters);
      }

      if ($child == 'ReportContractsAnalytical') {
        return this.$refs.ReportContractsAnalytical.generate(this.filters);
      }

      if ($child == 'ReportContractsReadjustment') {
        return this.$refs.ReportContractsReadjustment.generate(this.filters);
      }

      if ($child == 'ReportCustomersCnae') {
        return this.$refs.ReportCustomersCnae.generate(this.filters);
      }

      if ($child == 'ReportActives') {
        if (
          this.$refs.ReportActives.data.billing_month.length < 7 ||
          this.$refs.ReportActives.data.customers.length < 1
        ) {
          this.alert = {
            color: 'alert-brand',
            icon: 'fas fa-exclamation-triangle fa-lg',
            message: 'Selecione a data e os clientes...',
            reason: '',
          };
          this.loading = false;
          return;
        } else {
          this.clearAlert();
          return this.$refs.ReportActives.generate(this.filters);
        }
      }

      if ($child == 'ReportMonthlyData') {
        if (
          this.$refs.ReportMonthlyData.data.billing_month.length < 7 ||
          this.$refs.ReportMonthlyData.data.customers.length < 1
        ) {
          this.alert = {
            color: 'alert-brand',
            icon: 'fas fa-exclamation-triangle fa-lg',
            message: 'Selecione a data e os clientes...',
            reason: '',
          };
          this.loading = false;
          return;
        } else {
          this.clearAlert();
          return this.$refs.ReportMonthlyData.generate(this.filters);
        }
      }

      if ($child == 'ReportConsumptionAnalytics') {
        if (
          this.$refs.ReportConsumptionAnalytics.data.billing_month.length < 7 ||
          this.$refs.ReportConsumptionAnalytics.data.customer_id.length < 1
        ) {
          this.alert = {
            color: 'alert-brand',
            icon: 'fas fa-exclamation-triangle fa-lg',
            message: 'Selecione a data e o cliente...',
            reason: '',
          };
          this.loading = false;
          return;
        } else {
          this.clearAlert();
          return this.$refs.ReportConsumptionAnalytics.generate(this.filters);
        }
      }

      if ($child == 'ReportInvoiceAnalytics') {
        this.clearAlert();
        return this.$refs.ReportInvoiceAnalytics.generate(this.filters);
      }

      if ($child == 'ReportInvoiceAnalyticsByGroup') {
        this.clearAlert();
        return this.$refs.ReportInvoiceAnalyticsByGroup.generate(this.filters);
      }

      if ($child == 'ReportContractsChange') {
        return this.$refs.ReportContractsChange.generate(this.filters);
      }
      if ($child == 'ReportInvoiceAnalyticConsumptions') {
        return this.$refs.ReportInvoiceAnalyticConsumptions.generate(
          this.filters
        );
      }

      if ($child == 'ReportCustomerGriffinMktzap') {
        this.clearAlert();
        return this.$refs.ReportCustomerGriffinMktzap.generate(this.filters);
      }

      if ($child == 'ReportCustomerAttendanceProtocol') {
        return this.$refs.ReportCustomerAttendanceProtocol.generate(
          this.filters
        );
      }

      if ($child == 'ReportInvoiceCategories') {
        return this.$refs.ReportInvoiceCategories.generate(this.filters);
      }

      if ($child == 'ReportInvoiceAnalyticsGeneral') {
        return this.$refs.ReportInvoiceAnalyticsGeneral.generate(this.filters);
      }

      if ($child == 'ReportPartialInvoiceConsumption') {
        this.clearAlert();
        return this.$refs.ReportPartialInvoiceConsumption.generate(this.filters);
      }
      this.alert = {
        color: 'alert-brand',
        icon: 'fas fa-exclamation-triangle fa-lg',
        message: 'Selecione períodos e qual o tipo de relatório...',
        reason: '',
      };
    },
  },
  beforeMount() {
    this.filters.id = this.$route.params.groupId
      ? this.$route.params.groupId
      : '';
    if (this.$route.params.month && this.$route.params.year) {
      this.filters.billing_month = `${this.$route.params.month}/${this.$route.params.year}`;
    }
  },
  mounted() {
    if (this.filters.id && this.filters.report_type) {
      this.callData();
    } else {
      this.alert = {
        color: 'alert-brand',
        icon: 'fas fa-exclamation-triangle fa-lg',
        message: 'Selecione períodos e qual o tipo de relatório...',
        reason: '',
      };
    }
  },
};
</script>
